import { SetTotpMfa } from "@/features/account/components/change-details/set-mfa";

function MfaDetails() {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <h1 className="mb-4 text-2xl font-semibold">
                    Set up multi-factor authentication
                </h1>
                <SetTotpMfa />
            </div>
        </div>
    );
}

export default MfaDetails;
